import L from 'leaflet'
import { GestureHandling } from 'leaflet-gesture-handling';

// Doit être enregistré AVANT toute création de carte, sinon le handler ne s'attache pas
L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling)


export default class Map {
  constructor(el) {
    this.el = el
    this.container = el.querySelector('.map--container')
    if (!this.container) return
    this.init()
  }

  init() {
    const lat  = parseFloat(this.container.dataset.lat)
    const lng  = parseFloat(this.container.dataset.lng)
    const zoom = parseInt(this.container.dataset.zoom, 10)

    if (isNaN(lat) || isNaN(lng)) return

    const map = L.map(this.container, { gestureHandling: true })


    // Fond satellite (imagerie aérienne)
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Source: Esri, Vantor, Earthstar Geographics, and the GIS User Community',
      maxZoom: 19,
    }).addTo(map)

    // Calques de labels par-dessus : routes puis noms de lieux
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 19,
      pane: 'overlayPane',
    }).addTo(map)

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 19,
      pane: 'overlayPane',
    }).addTo(map)

    const redPin = L.divIcon({
      className: '',
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41"><path d="M12.5 0C5.6 0 0 5.6 0 12.5C0 21.9 12.5 41 12.5 41S25 21.9 25 12.5C25 5.6 19.4 0 12.5 0Z" fill="#cc2200"/><circle cx="12.5" cy="12.5" r="4.5" fill="white"/></svg>`,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
    })

    map.setView([lat, lng], zoom)
    L.marker([lat, lng], { icon: redPin })
      .addTo(map)
      .on('click', () => {
        window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank')
      })
  }
}
